import {
  HomePageRandomJoke,
  HomePageStarredEntities,
  CustomHomepageGrid, QuickStartCard, HomePageCompanyLogo,
  WelcomeTitle,
  HomepageCompositionRoot,
  HomePageTopVisited,
  HomePageRecentlyVisited,
  FeaturedDocsCard,
  HeaderWorldClock,
  HomePageToolkit,
  TemplateBackstageLogoIcon,
  RendererProps
} from '@backstage/plugin-home';
import {
  Page,
  Content,
  Header,
  InfoCard,
} from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { Grid, GridList, makeStyles, Typography } from '@material-ui/core';
import { AnnouncementsCard } from '@backstage-community/plugin-announcements';


  const tools = [
    { label: 'Remine', url: '/url', icon: <div>icon</div> },
    { label: 'tool 2', url: '/url-2', icon: <div>icon 2</div> },
  ];

export const homePage = (

 

  <>
      <Header
      title={<WelcomeTitle language={['Spanish']} />}
      pageTitleOverride="Home"
    />

  <Content>
  
  <Grid container spacing={3} title='adsdas'>


    <Grid item xs={6}>
      <AnnouncementsCard max={3} />
    </Grid>
    <Grid item xs={6}>
      <HomePageStarredEntities />
    </Grid>
           <Grid item xs={12}>
            <HomePageToolkit
          title="Utilidades"
          tools={tools}
        />
        </Grid>
  </Grid>

      <CustomHomepageGrid >
        <QuickStartCard
          title="Onboarding to the Catalog"
          modalTitle="Onboarding Quick Start"
          docsLinkTitle="Learn more with getting started docs"
          docsLink="https://backstage.io/docs/getting-started"
          cardDescription="Backstage system model will help you create new entities"
          additionalContent={<p>
            This is a custom description for the Quick Start card. It can be
            used to provide additional information or context about the Quick
            Start process.
          </p>}
           image={<img src="path/to/your/image.png" alt="Quick Start" style={{ width: '100%', height: '100%' }} />}
          />
        <HomePageSearchBar />
        <HomePageRandomJoke />

      </CustomHomepageGrid>

</Content>
</>

);


function ExpandedComponentAccordion(props: RendererProps): Element {
  throw new Error('Function not implemented.');
}

